import { useMemo } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useGamesStore, useGetWagerSlotsGamesIds } from '../../store';

export const usePrepareCategoriesForSearchFilter = (feedName) => {
  const feeds = useGamesStore('feeds');
  const gamesFeed = feeds[feedName];
  const { categories } = gamesFeed || {};

  const wagerSlotGamesIds = useGetWagerSlotsGamesIds(feedName);
  const { casinoDynamicCategoriesIds = {} } = useOtherSettings();

  const wagerSlotsCategoryName = casinoDynamicCategoriesIds.wagerSlots;
  const liveRtpCategoryName = casinoDynamicCategoriesIds.liveRtp;

  const preparedCategories = useMemo(
    () => ({
      ...categories,
      data: {
        ...(categories?.data ?? {}),
        [wagerSlotsCategoryName]: {
          ...(categories?.data?.[wagerSlotsCategoryName] ?? {}),
          games: wagerSlotGamesIds
        }
      },
      ids: categories?.ids?.filter(
        (categoryName) => categoryName !== liveRtpCategoryName
      )
    }),
    [categories, wagerSlotGamesIds, wagerSlotsCategoryName, liveRtpCategoryName]
  );

  return preparedCategories;
};
